import styled from "styled-components";

const Align = styled.div`
	text-align: ${({ direction = "left" }) => direction};
`;

export default Align;
